import React from 'react'
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="site-footer section-padding">
        <div className="container">
            <div className="row">

                <div className="col-lg-3 col-12 mb-4 pb-2">
                    <Link className="navbar-brand mb-2" to="/">
                        <i className="bi-back"></i>
                        <span> just59</span>
                    </Link>
                </div>

                <div className="col-lg-3 col-md-4 col-6">
                    <h6 className="site-footer-title mb-3">Resources</h6>

                    <ul className="site-footer-links">
                        <li className="site-footer-link-item">
                            <Link to="/" className="site-footer-link">Home</Link>
                        </li>

                        {/* <li className="site-footer-link-item">
                            <Link to="#" className="site-footer-link">Browse Calculators</Link>
                        </li> */}

                        <li className="site-footer-link-item">
                            <Link to="/about-us" className="site-footer-link">About us</Link>
                        </li>

                        <li className="site-footer-link-item">
                            <Link to="/faqs" className="site-footer-link">FAQs</Link>
                        </li>

                        <li className="site-footer-link-item">
                            <Link to="/contact" className="site-footer-link">Contact Us</Link>
                        </li>
                    </ul>
                </div>

                <div className="col-lg-3 col-md-4 col-6 mb-4 mb-lg-0">
                    <h6 className="site-footer-title mb-3">Information</h6>

                    {/* <p className="text-white d-flex mb-1">
                        <a href="tel: +91 935 290 4020" className="site-footer-link">
                            +91 935 290 4020
                        </a>
                    </p> */}

                    <p className="text-white d-flex">
                        <a href="mailto:just59@gmail.com" className="site-footer-link">
                            just59@gmail.com
                        </a>
                    </p>
                </div>

                <div className="col-lg-3 col-md-4 col-12 mt-4 mt-lg-0 ms-auto">
                    {/* <div className="dropdown">
                        <button className="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            English</button>

                        <ul className="dropdown-menu">
                            <li><button className="dropdown-item" type="button">Thai</button></li>

                            <li><button className="dropdown-item" type="button">Myanmar</button></li>

                            <li><button className="dropdown-item" type="button">Arabic</button></li>
                        </ul>
                    </div> */}

                    <p className="copyright-text mt-lg-5 mt-4">Copyright © {new Date().getFullYear()} just59 Technologies. All rights reserved.
                        {/* <br/><br/>Design: <a rel="nofollow" href="https://templatemo.com" target="_blank">TemplateMo</a> */}
                    </p>

                </div>

            </div>
        </div>
    </footer>
  )
}

export default Footer
